export const config = {
  // BACKENDURL: "http://localhost:8000/",
  BACKENDURL: "https://api.aladeeswararkovil.in/",
  GOOGLEAPIKEY: "AIzaSyAH5htDjzEuQ05bWjXIKu7EeUNPtzrOApw",
};
